import AIFeedback from 'shared_ui_components/AIFeatures/AIFeedback/AIFeedback';
import { Skeleton } from '@material-ui/lab';
import classes from './ReportResult.module.css';
const Feedback = ({ feedback = '', readOnly = false, status_ai, isLoadingResponse = false }) => {
  if (readOnly)
    return (
      <div>
        <h4>🙌 Overall Feedback</h4>
        <AIFeedback ai_feedback_status={'SUCCEEDED'} ai_feedback={feedback} interactiveRoleplay />
      </div>
    );

  return (
    <div>
      <h4>🙌 Overall Feedback</h4>
      {isLoadingResponse ? (
        <div className={classes.overallFeedback}>
          <Skeleton variant="rect" width="100%" height="10vh" style={{ borderRadius: '0.5rem' }} />
        </div>
      ) : (
        <AIFeedback ai_feedback_status={status_ai} ai_feedback={feedback} interactiveRoleplay />
      )}
    </div>
  );
};

export default Feedback;
